var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSecurefileBetaFeatureIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 12,
    viewBox: "0 0 26 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "BETA",
    transform: "translate(-909.416 -251)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1829",
    "data-name": "Rectangle 1829",
    width: 26,
    height: 12,
    rx: 3,
    transform: "translate(909.416 251)",
    fill: "#b926c9"
  }), /*#__PURE__*/React.createElement("text", {
    id: "BETA-2",
    "data-name": "BETA",
    transform: "translate(913.916 259.5)",
    fill: "#fff",
    fontSize: 7,
    fontFamily: "Silka-SemiBold, Silka",
    fontWeight: 600,
    letterSpacing: "0.024em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "BETA")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecurefileBetaFeatureIcon);
export default __webpack_public_path__ + "static/media/securefile-beta-feature-icon.3b688206ab27ebcf693b4e3e03d4d392.svg";
export { ForwardRef as ReactComponent };